import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Stack,
  Switch,
  TextareaAutosize,
  IconButton,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useAppServices, useUploadImage } from 'hook/services'
import { useUserInfo } from 'context/user'
import MDInput from 'components/MDInput'
import Multiselect from '../CreateModal/components/Multiselect'
import './index.css'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  height: '80vh',
  overflow: 'auto',
  bgcolor: 'background.paper',
  border: '2px  #000',
  boxShadow: 24,
  p: 4,
}

const EditModal = ({
  data,
  handleRefresh,
  Categories,
  Types,
  Tags,
  Dash_tags,
  business_types,
  staff,
}) => {



  const uploadImage = useUploadImage()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const AppService = useAppServices()
  const [user] = useUserInfo()

  // Convert staff data to the format needed for Multiselect
  const staffOptions = staff?.map((item) => ({
    label: item?.username,
    value: item?._id,
  }))

  // Convert existing assignees to the format needed for Multiselect
  const initialStaffSelection = data?.assignees?.map((assignee) => ({
    label: assignee.name,
    value: assignee.id,
  })) || []

  const types = [
    { label: 'Agency', value: 'agency' },
    { label: 'Subaccount', value: 'sub_account' },
    { label: 'Agency & Subaccount', value: 'both' },
  ]

  const integration_type = [
    { label: 'Basic', value: 'basic' },
    { label: 'Iframe', value: 'iframe' },
    { label: 'Url', value: 'url' },
    { label: 'Form', value: 'form' },
  ]

  const roadmapStatus = [
    { label: 'Wish List', value: 'wish-list' },
    { label: 'Planned', value: 'planned' },
    { label: 'In Progress', value: 'in-progress' },
    { label: 'Testing (Beta)', value: 'testing' },
    { label: 'Completed', value: 'completed' },
  ]
  const marketPlace_status = [
    { label: 'Public', value: 'public' },
    { label: 'Private', value: 'private' },
    { label: 'In Progress', value: 'inprogress' },
    { label: 'Submit For Review', value: 'submitforreview' },
    { label: 'RoadMap', value: 'roadmap' },
  ]


  const status = [
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' },
    { label: 'Beta', value: 'beta' },
  ]

  const FeaturesList = [
    { label: 'Snapshot', value: 'snapshot' },
    { label: 'Widget', value: 'widget' },
    { label: 'Custom Js', value: 'custom_js' },
    { label: 'Payment Provider', value: 'payment_provider' },
    { label: 'Actions', value: 'actions' },
    { label: 'Triggers', value: 'triggers' },
    { label: 'Conversation Providers', value: 'conversation_providers' },
  ]
  const roadmap_type = [
    { label: 'All the Apps', value: 'All the Apps' },
    { label: 'All the Apps Agency', value: 'All the Apps Agency' },
    { label: 'All the Apps AI', value: 'All the Apps AI' },
    { label: 'App Creater', value: 'App Creater' },
    { label: 'Apps', value: 'Apps' },

  ]
  const handlemodal = () => {
    setOpenAddProduct(true)
  }


  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)
    const [goingToLive, setGoingToLive] = useState(data?.status !== 'inactive')
    const [selectedStaff, setSelectedStaff] = useState([])

    // Show existing images and allow adding new ones

    const handleCheckboxChange = (event) => {
      setGoingToLive(event.target.checked)
    }

    // Handle staff selection change
    const handleStaffChange = (selectedOptions) => {
      setSelectedStaff(selectedOptions || [])
    }


    const handleSubmit = async (e) => {
      e.preventDefault()

      if (
        goingToLive &&
        !e.target?.app_id?.value &&
        !e.target?.client_id?.value &&
        !e.target?.client_secret?.value &&
        !e.target?.sso?.value
      ) {
        alert('Please must add required inputs to make the app publish')
        return false
      }
      setProcessing(true)

      let image_response = data.image
      if (e.target?.image?.files?.[0] && goingToLive) {
        const response_data = await uploadImage({
          file: e.target.image.files[0],
          desiredPath: `app/logo/image`,
        })
        if (response_data.response) {
          image_response = response_data.response.data
        }
      }

      function tryParseJSON(jsonString, defaultValue) {
        if (!jsonString) return defaultValue
        try {
          return JSON.parse(jsonString)
        } catch (error) {
          console.error('Failed to parse JSON:', error)
          return defaultValue
        }
      }

      // Convert selected staff to the required format
      // const assignees = selectedStaff.map((staff) => ({
      //   id: staff.value,
      //   name: staff.label,
      // }))
      const assignees = tryParseJSON(e.target.assignees?.value, [])


      const payload = {
        _id: data?._id || '',
        name: e.target.name?.value || '',
        description: e.target.description?.value || '',
        video_url: e.target.video_url?.value || '',
        url: e.target.url?.value || '',
        custom_page: e.target.custom_page?.value || '',
        custom_page_for_all_the_app: e.target.custom_page_for_all_the_app?.value || '',
        custom_page_for_account_booster: e.target.custom_page_for_account_booster?.value || '',



        agency_custom_page: e.target.agency_custom_page?.value || '',
        user_id: user?._id || '',
        image: image_response || null,
        app_triggers: Boolean(e.target.app_triggers?.checked),
        hasUIInterface: Boolean(e.target.hasUIInterface?.checked),
        default_app: Boolean(e.target.default_app?.checked),
        ghl_add_on: Boolean(e.target.ghl_add_on?.checked),
        location_tool: Boolean(e.target.location_tool?.checked),
        is_blackBox: Boolean(e.target.is_blackBox?.checked),
        dont_show: Boolean(e.target.dont_show?.checked),
        add_on_roadmap_enable: Boolean(e.target.add_on_roadmap_enable?.checked),
        //testing

        dont_show_location: Boolean(e.target.dont_show_location?.checked),
        included_all_the_apps: Boolean(e.target.included_all_the_apps?.checked),
        ...(e.target.app_id?.value && { app_id: e.target.app_id.value }),
        ...(e.target.client_id?.value && { client_id: e.target.client_id.value }),
        ...(e.target.client_secret?.value && { client_secret: e.target.client_secret.value }),
        ...(e.target.sso?.value && { sso: e.target.sso.value }),
        ...(e.target.nav_icon?.value && { nav_icon: e.target.nav_icon.value }),
        staff: tryParseJSON(e.target.staff?.value, []),
        categories: tryParseJSON(e.target.categories?.value, []),
        app_features: tryParseJSON(e.target.app_features?.value, []),
        roadmap_type: tryParseJSON(e.target.roadmap_type?.value, []),
        marketPlace_status: tryParseJSON(e.target.marketPlace_status?.value, []),
        start_date: e.target.start_date?.value || '',
        end_date: e.target.end_date?.value || '',
        assignees: assignees,



        app_subscription_type: tryParseJSON(e.target.app_subscription_type?.value, ''),
        status: tryParseJSON(e.target.status?.value, ''),
        roadmap_status: tryParseJSON(e.target.roadmap_status?.value, ''),
        ad_on_roadmap_status: tryParseJSON(e.target.ad_on_roadmap_status?.value, ''),


        distinguish_type: tryParseJSON(e.target.distinguish_type?.value, {}),
        business_type: tryParseJSON(e.target.business_type?.value, {}),
        tags: tryParseJSON(e.target.tags?.value, []),
        dash_tags: tryParseJSON(e.target.dash_tags?.value, []),

      }


      const { response } = await AppService.app.update({
        payload: payload,
      })
      if (response) {
        setProcessing(false)
        onClose()
        // handleRefresh()
      }
    }

    const closeAddProduct = () => {
      setOpenAddProduct(false)
    }

    return (
      <MDModal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Update App
            </MDTypography>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Name
              </MDTypography>
              <MDInput label="Name" name="name" fullWidth defaultValue={data?.name} />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Description
              </MDTypography>
              <MDBox>
                <TextareaAutosize
                  type="text"
                  name="description"
                  defaultValue={data?.description}
                  minRows={3}
                  style={{ width: '100%' }}
                />
              </MDBox>
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Categories
              </MDTypography>
              <Multiselect
                data={Categories}
                edit_data={data.categories}
                isMulti={true}
                name="categories"
              />
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Type
              </MDTypography>
              <Multiselect
                data={Types}
                edit_data={data.distinguish_type}
                isMulti={false}
                name="distinguish_type"
              />
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Assignees
              </MDTypography>
              <Multiselect
                data={staffOptions}
                edit_data={initialStaffSelection} // Use the initial data instead of selectedStaff
                isMulti={true}
                name="assignees"
              // Remove the onChange prop
              />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Video Url
              </MDTypography>
              <MDInput
                defaultValue={data?.video_url}
                label="Video Url"
                name="video_url"
                fullWidth
              />
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                App Features
              </MDTypography>
              <Multiselect
                data={FeaturesList}
                edit_data={data?.app_features}
                isMulti={true}
                name="app_features"
              />
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Roadmap Type
              </MDTypography>
              <Multiselect
                data={roadmap_type}
                edit_data={data?.roadmap_type}
                isMulti={true}
                name="roadmap_type"
              />
            </MDBox>

            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Status
              </MDTypography>
              <Multiselect data={status} edit_data={data.status} isMulti={false} name="status" />
            </MDBox>
            <MDBox sx={{ fontSize: '15px', marginTop: '10px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Roadmap Status
              </MDTypography>
              <Multiselect
                data={roadmapStatus}
                edit_data={data?.roadmap_status}
                isMulti={false}
                name="roadmap_status"
              />
            </MDBox>
            <MDBox sx={{ fontSize: '15px', marginTop: '10px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Ad On Roadmap Status
              </MDTypography>
              <Multiselect
                data={roadmapStatus}
                edit_data={data?.ad_on_roadmap_status}
                isMulti={false}
                name="ad_on_roadmap_status"
              />
            </MDBox>


            {/* <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                 Status
              </MDTypography>
              <Multiselect data={status} edit_data={data.status} isMulti={false} name="status" />
            </MDBox> */}
            <MDBox sx={{ fontSize: '15px', marginTop: '10px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                MarketPlace Status
              </MDTypography>
              <Multiselect
                data={marketPlace_status}
                edit_data={data?.marketPlace_status}
                isMulti={false}
                name="marketPlace_status"
              />
            </MDBox>



            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Form url
              </MDTypography>
              <MDInput defaultValue={data?.url} label="url" name="url" fullWidth />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Custom Page
              </MDTypography>
              <MDInput
                defaultValue={data?.custom_page}
                label="custom_page"
                name="custom_page"
                fullWidth
              />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Custom Page For All The App
              </MDTypography>
              <MDInput label="custom_page_for_all_the_app" name="custom_page_for_all_the_app" fullWidth />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Custom Page For Account Booster
              </MDTypography>
              <MDInput label="custom_page_for_account_booster" name="custom_page_for_account_booster" fullWidth />
            </MDBox>
            <MDBox>
              <MDTypography
                variant="button"
                sx={{ fontSize: '14px', fontWeight: '500' }}
                mb={1}
              >
                Start Date
              </MDTypography>

              <MDInput
                type="date"
                defaultValue={data?.start_date}
                label="Start Date"
                name="start_date"
                fullWidth
              />
            </MDBox>
            <MDBox>
              <MDTypography
                variant="button"
                sx={{ fontSize: '14px', fontWeight: '500' }}
                mb={1}
              >
                End Date
              </MDTypography>

              <MDInput
                type="date"
                defaultValue={data?.end_date}
                label="End Date"
                name="end_date"
                fullWidth
              />
            </MDBox>
            <MDBox
              mt={2}
              mb={2}
              ml={0}
              display="flex"
              alignItems="start"
              flexDirection="column"
            >
              <MDTypography
                variant="button"
                sx={{ fontSize: '14px', fontWeight: '500' }}
                mb={1}
              >
                App Images
              </MDTypography>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                  Upload Image +
                  <input hidden name="image" type="file" />
                </Button>
              </Stack>
            </MDBox>

            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked={data?.app_triggers} />}
                  label="Is App Have Triggers"
                  name="app_triggers"
                />
              </FormGroup>
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked={data?.hasUIInterface} />}
                  label="Is App Have Trigger Interface"
                  name="hasUIInterface"
                />
              </FormGroup>
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked={data?.default_app} />}
                  label="mark as default alltheapps App"
                  name="default_app"
                />
              </FormGroup>
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked={data?.included_all_the_apps} />}
                  label="Is it included in all the apps"
                  name="included_all_the_apps"
                />
              </FormGroup>
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked={data?.dont_show} />}
                  label="Hide App"
                  name="dont_show"
                />
              </FormGroup>
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked={data?.add_on_roadmap_enable} />}
                  label="Add On Roadmap Enable"
                  name="add_on_roadmap_enable"
                />
              </FormGroup>
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={goingToLive}
                      onChange={handleCheckboxChange}
                      name="is_going_to_live"
                    />
                  }
                  label="App ready to publish"
                />
              </FormGroup>
            </MDBox>

            {goingToLive && (
              <>
                <hr />

                <MDBox>
                  <MDTypography
                    variant="button"
                    sx={{ fontSize: '14px', fontWeight: '500' }}
                    mb={1}
                  >
                    App Id
                  </MDTypography>
                  <MDInput
                    label="App Id"
                    defaultValue={data?.app_id}
                    placeholder="App Id"
                    name="app_id"
                    fullWidth
                  />
                </MDBox>
                <MDBox>
                  <MDTypography
                    variant="button"
                    sx={{ fontSize: '14px', fontWeight: '500' }}
                    mb={1}
                  >
                    Client Id
                  </MDTypography>
                  <MDInput
                    label="Client Id"
                    defaultValue={data?.client_id}
                    placeholder="Client Id"
                    name="client_id"
                    fullWidth
                  />
                </MDBox>
                <MDBox>
                  <MDTypography
                    variant="button"
                    sx={{ fontSize: '14px', fontWeight: '500' }}
                    mb={1}
                  >
                    Client Secret
                  </MDTypography>
                  <MDInput
                    label="Client Secret"
                    placeholder="Client Secret"
                    name="client_secret"
                    defaultValue={data?.client_secret}
                    fullWidth
                  />
                </MDBox>
                <MDBox>
                  <MDTypography
                    variant="button"
                    sx={{ fontSize: '14px', fontWeight: '500' }}
                    mb={1}
                  >
                    SSO Key
                  </MDTypography>
                  <MDInput
                    label="SSO Key"
                    placeholder="SSO Key"
                    name="sso"
                    defaultValue={data?.sso}
                    fullWidth
                  />
                </MDBox>
              </>
            )}


            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 4, mb: 1 }}
                onClick={closeAddProduct}
              >
                close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 4, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Update
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }

  const closeAddProduct = () => {
    setOpenAddProduct(false)
  }

  return (
    <>
      <MDButton
        size="small"
        sx={{ marginRight: 2 }}
        color="info"
        variant="contained"
        onClick={handlemodal}
      >
        Edit
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  )
}

export default EditModal